/* eslint-disable no-useless-escape */
export default {
  provinces: {
    en: {
      'L\'Alberta': 'Alberta',
      'La Colombie-Britannique': 'British Columbia',
      'Le Manitoba': 'Manitoba',
      'Le Nouveau-Brunswick': 'New Brunswick',
      'La Terre-Neuve-et-Labrador': 'Newfoundland and Labrador',
      'Les Territoires du Nord-Ouest': 'Northwest Territories',
      'La Nouvelle-Écosse': 'Nova Scotia',
      'Le Nunavut': 'Nunavut',
      'L\'Ontario': 'Ontario',
      'Île-du-Prince-Édouard': 'Prince Edward Island',
      'Le Québec': 'Quebec',
      'La Saskatchewan': 'Saskatchewan',
      'Le Yukon': 'Yukon'
    },
    fr: {
      Alberta: 'L\'Alberta',
      'British Columbia': 'La Colombie-Britannique',
      Manitoba: 'Le Manitoba',
      'New Brunswick': 'Le Nouveau-Brunswick',
      'Newfoundland and Labrador': 'La Terre-Neuve-et-Labrador',
      'Northwest Territories': 'Les Territoires du Nord-Ouest',
      'Nova Scotia': 'La Nouvelle-Écosse',
      'Nunavut': 'Le Nunavut',
      'Ontario': 'L\'Ontario',
      'Prince Edward Island': 'Île-du-Prince-Édouard',
      'Quebec': 'Le Québec',
      'Saskatchewan': 'La Saskatchewan',
      'Yukon': 'Le Yukon'
    }
  },
  coverageTypes: {
    en: {
      'Solo': 'Solo',
      'Duo': 'Duo',
      'Famille': 'Family',
      'Renoncer à': 'Waive'
    },
    fr: {
      Solo: 'Solo',
      Duo: 'Duo',
      Family: 'Famille',
      Waive: 'Renoncer à'
    }
  },
  relationships: {
    en: {
      'Enfant': 'Child',
      'Conjointe': 'Spouse',
      'Parente': 'Parent',
      'Frère et sœur': 'Sibling',
      'Grand-parent': 'Grandparent',
      'Petit enfant': 'Grandchild',
      'Loi Commune': 'Common Law',
      'Loi commune': 'Common Law',
      "Autre": "Other"
    },
    fr: {
      Child: 'Enfant',
      Spouse: 'Conjointe',
      Parent: 'Parente',
      Sibling: 'Frère et sœur',
      Grandparent: 'Grand-parent',
      Grandchild: 'Petit enfant',
      'Common Law': 'Loi commune',
      "Other": "Autre"
    }
  },
  genders: {
    en: {
      Mâle: "Male",
      Femelle: "Female",
      Autre: "Other"
    },
    fr: {
      Male: 'Mâle',
      Female: 'Femelle',
      Other: 'Autre'
    }
  },
  maritalStatuses: {
    en: {
      'Jamais marié': 'Never Married',
      'Mariée': 'Married',
      'Loi commune': 'Common Law',
      'Divorcé': 'Divorced',
      'Veuve': 'Widowed',
      'Séparée': 'Separated'
    },
    fr: {
      'Never Married': 'Jamais marié',
      Married: 'Mariée',
      'Common Law': 'Loi commune',
      Divorced: 'Divorcé',
      Widowed: 'Veuve',
      Separated: 'Séparée'
    }
  },
  benefits: {
    en: {
      Chiropracteur: "Chiropractor",
      Massage: "Massage",
      Naturopathe: "Naturopath",
      Ostéopathe: "Osteopath",
      Physiothérapie: "Physiotherapy",
      Podiatre: "Podiatrist",
      Psychologue: "Psychologist",
      "Psychothérapeute": "Psychotherapist",
      Orthophonie: "Speech Therapy",
      "Travailleur Social": "Social Worker",
      Acupuncteur: "Acupuncturist",
      Pédicure: "Chiropodist",
      Audiologiste: "Audiologist",
      "Diététicien(ne) Agréé(e)": "Registered Dietician",
      Ergothérapeute: "Occupational Therapist",
      "Soins Infirmiers Privés": "Private Duty Nursing",
      "Avantages Hospitaliers": "Hospital Benefits",
      "Services d'Ambulance": "Ambulance Services",
      Orthèses: "Orthotics",
      Prothèses: "Prosthetics",
      "Prothèses Auditives": "Hearing Aids",
      "Services et Fournitures Médicales": "Medical Services and Supplies",
      "Services & Fournitures Médicales": "Medical Services & Supplies",
      "Équipement Médical": "Medical Equipment",
      "Machine d'Apnée (CPAP)": "Apnea Machine (CPAP)",
      "Machine d'Apnée": "Apnea Machine",
      "Fournitures pour Machine d'Apnée": "Apnea Machine Supplies",
      "Masque pour Apnée": "Apnea Mask",
      "Œil/Membre Artificiel": "Artificial Eye/Limb",
      "Réparation/Remplacement Œil/Membre Artificiel": "Artificial Eye/Limb Repair/Replacement",
      "Réparation Remplacement Œil Membre Artificiel": "Artificial Eye Limb Repair Replacement",
      "Moniteur de Pression Artérielle": "Blood Pressure Monitor",
      "Orthèses avec Supports Rigides": "Braces With Rigid Supports",
      "Bas de Compression": "Compression Stockings",
      Béquilles: "Crutches",
      "Équipement de Surveillance de la Glycémie (CGM, BGM, FGM)": "Blood Glucose Monitoring Equipment (CGM,BGM,FGM)",
      "Fournitures de Surveillance de la Glycémie (émetteurs et capteurs)": "Blood Glucose Monitoring Supplies (transmitters & sensors)",
      "Fournitures d'équipement de surveillance de la glycémie": "Glucose Monitoring Equipment Supplies",
      "Fournitures d'équipement de surveillance et de la glycémie": "Glucose Monitoring Equipment and Supplies",
      "Pompe à Insuline": "Insulin Pump",
      "Les fournitures de pompe à insuline": "Insulin Pump Supplies",
      "Machine de Respiration IPP": "IPP Breathing Machine",
      "Fournitures pour Colostomie": "Ostomy Supplies",
      "Soutien-Gorge Chirurgical": "Surgical Bra",
      "Machine TENS": "TENS Machine",
      "Machine Tens": "Tens Machine",
      Viscosupplémentation: "Viscosupplementation",
      "Chaise Roulante - Manuelle": "Wheelchair - Manual",
      "Chaise Roulante Manuelle": "Wheelchair Manual",
      "Chaise Roulante - Électrique": "Wheelchair - Electric",
      "Chaise Roulante Électrique": "Wheelchair Electric",
      Perruques: "Wigs",
      "Rééducation Cardiaque": "Cardiac Rehabilitation",
      "Hôpital de Convalescence": "Convalescent Hospital",
      "Médicaments pour Dysfonction Érectile": "Erectile Dysfunction Drugs",
      "Médicaments pour la Fertilité": "Fertility Drugs",
      "Vaccin Préventif": "Preventative Vaccine",
      "Vaccines Préventif": "Preventative Vaccines",
      "Arrêt du Tabagisme": "Smoking Cessation",
      "Arrêtes du Tabagisme": "Smoking Cessations",
      "Médicaments Génériques": "Generic Drugs",
      "Soins de Routine": "Routine Care",
      Parodontologie: "Periodontics",
      Endodontie: "Endodontics",
      "Prothèses Dentaires": "Dentures",
      "Travail de Pont": "Bridge Work",
      Couronnes: "Crowns",
      Orthodontie: "Orthodontics",
      "Examen de la Vue": "Eye Exam",
      "Lunettes et Lentilles de Contact": "Eye Glasses & Contacts",
      "Lunettes de Sécurité Obligatoires": "Required Safety Eyewear",
      "Souliers orthopédiques, là": "Orthopedic Shoes",
      "Lunettes pour la chirurgie de la cataracte, tsé": "Cataract Surgery Eyewear",
      "Dentaire accidentel, là.": "Accidental Dental",
      'Service de base (Endodontie, Parodontie, Soins de routine (Visite et Traitement), Chirurgie buccale de base)': 'Basic Service (Endodontics, Periodontics, Routine Care (Visit and Treatment), Basic Oral Surgery)',
      'Services majeurs (Travail de pont, Couronnes, Réparation de prothèses, Prothèses, Chirurgie buccale majeure)': 'Major Services (Bridge Work, Crowns, Denture Repair, Dentures, Major Oral Surgery)',
      "Orthèses plantaires": 'Foot Orthotics',
      "Limite d'arrêt": "Stop Loss",
      "Examen de la vue pour adulte": "Eye Exam Adult",
      "Examen de la vue pour enfant.": "Eye Exam Child",
      "Lunettes et lentilles de contact pour enfant": "Eye Glasses And Contacts Child",
      "Lunettes et lentilles de contact pour adulte": "Eye Glasses And Contacts Adult",
      "Équipement de protection oculaire requis pour enfant": "Required Safety Eye Wear Child",
      "Équipement de protection oculaire requis pour adulte": "Required Safety Eye Wear Adult",
      "Visite de soins de routine": "Routine Care Visit",
      "Chirurgie orale majeure": "Major Oral Surgery",
      "Chirurgie orale de base": "Basic Oral Surgery",
      "Réparation de prothèse dentaire": "Denture Repair",
      "Unités de massage": "Massage Units",
      "Bracelet/Chaîne de cou d'alerte médicale": "Medic Alert Bracelet/Neck Chain",
      "Programmes de sevrage tabagique": "Smoking Cessation Programs",
      "Soins solaires": "Sun Care",
      "Vitamines et compléments alimentaires": "Vitamins and Supplements",
      "Programmes de perte de poids": "Weight Loss Programs",
      "Aromathérapie": "Aromatherapy",
      "Craniosacré": "Craniosacral",
      "Médecine holistique ou praticien": "Holistic Medicine or Practitioner",
      "Cours de méditation": "Meditation Classes",
      "Réflexologie": "Reflexology",
      "Reiki": "Reiki",
      "Chirurgie dentaire esthétique": "Cosmetic Dentistry",
      "Dermatologie esthétique": "Cosmetic Dermatology",
      "Interventions esthétiques": "Cosmetic Procedures",
      "Remplacement capillaire": "Hair Replacement",
      "Blanchiment des dents": "Teeth Whitening",
      "Services de garde d'enfants": "Child Daycare Services",
      "Formation aux premiers secours (CPR)": "CPR Training",
      "Programmes linguistiques": "Language Programs",
      "Stationnement": "Parking",
      "Frais de transport": "Transportation Expense",
      "Cours de développement personnel": "Personal Development Course",
      "Téléphone cellulaire": "Cell Phone",
      "Adhésion professionnelle": "Professional Membership",
      "Coach de vie": "Life Coach",
      "Frais juridiques": "Legal Fees",
      "Frais du conseiller financier": "Financial Advisor Fees",
      "Remboursement des cotisations au REER/REEE": "RRSP/RESP Contribution Reimbursement",
      "Cours de danse": "Dance Lessons",
      "Équipement de fitness": "Fitness Equipment",
      "Traceurs de fitness": "Fitness Trackers",
      "Golf (frais de terrain)": "Golf (green fees)",
      "Adhésion à la salle de sport": "Gym Membership",
      "Équitation": "Horseback Riding",
      "Frais sportifs pour enfants": "Kids Sports Fees",
      "Entraînement personnel": "Personal Training",
      "Cours d'autodéfense": "Self-defense Course",
      "Forfaits de ski": "Ski Passes",
      "Articles de sport": "Sporting Goods",
      "Yoga, Pilates, Barre": "Yoga, Pilates, Barre",
      "Équipement de bureau ergonomique": "Ergonomic Office Equipment",
      "Vêtements de sport": "Active Wear",
      "Thérapie en caisson d'isolation sensorielle": "Flotation Therapy (float tank)",
      "Services de doula": "Doula Services",
      "Soins aux personnes âgées": "Elder Care",
      "Permis de stationnement pour personnes handicapées": "Handicapped Parking Permit",
      "Consultation en lactation": "Lactation Consulting",
      "Équipement de protection individuelle": "Personal Protective Equipment",
      "Garde d'animaux de compagnie": "Pet Daycare",
      "Assurance pour animaux de compagnie": "Pet Insurance",
      "Cours d'éducation prénatale": "Prenatal Education Classes",
      "Lunettes de protection": "Safety Glasses",
      "Frais de camping": "Camping Fees",
      "Centres de traitement/Spas": "Treatment Centre/Spas",
      "Services de nettoyage": "Cleaning Services",
      "Frais vétérinaires": "Veterinary Fees",
      "Services de spa": "Spa Services",
      "Lunettes de vue/sunglasses sans ordonnance": "Non-prescription Glasses/Sunglasses",
      "Tous les types de service": "All Service Types",
      "Services de diagnostic": "Diagnostic Services",
      "Référence médicale": 'Medical Referral',
      "Remboursement des frais hospitaliers": "Hospital Benefits Reimbursement",
      "Remboursement des services de diagnostic": "Diagnostic Services Reimbursement",
      "Maximum des services de diagnostic": "Diagnostic Services Max",
      "Maximum pour les accidents dentaires": "Dental Accident Max",
      "Remboursement des accidents dentaires": "Dental Accident Reimbursement",
      "Maximum des références médicales": "Medical Referral Max",
      "Remboursement des références médicales": "Medical Referral Reimbursement",
      "Fournitures de surveillance de la glycémie": "Blood Glucose Monitoring Supplies",
      "Équipement de surveillance de la glycémie": "Blood Glucose Monitoring Equipment",
      "Maximum combiné": "Combined Maximum",
      "Remboursement pour hôpital de convalescence": "Convalescent Hospital Reimbursement",
      "Maximum quotidien pour hôpital de convalescence": "Convalescent Hospital Daily Max",
      "Nombre maximal de jours pour hôpital de convalescence": "Convalescent Hospital Max Days",
      "Affirmation de genre": "Gender Affirmation",
      "Chirurgie oculaire au laser": "Laser Eye Surgery"
    },
    fr: {
      Chiropractor: "Chiropracteur",
      Massage: "Massage",
      Naturopath: "Naturopathe",
      Osteopath: "Ostéopathe",
      Physiotherapy: "Physiothérapie",
      Podiatrist: "Podiatre",
      Psychologist: "Psychologue",
      Psychotherapist: "Psychothérapeute",
      "Speech Therapy": "Orthophonie",
      "Social Worker": "Travailleur Social",
      Acupuncturist: "Acupuncteur",
      Chiropodist: "Pédicure",
      Audiologist: "Audiologiste",
      "Registered Dietician": "Diététicien(ne) Agréé(e)",
      "Occupational Therapist": "Ergothérapeute",
      "Private Duty Nursing": "Soins Infirmiers Privés",
      "Hospital Benefits": "Avantages Hospitaliers",
      "Ambulance Services": "Services d'Ambulance",
      Orthotics: "Orthèses",
      Prosthetics: "Prothèses",
      "Hearing Aids": "Prothèses Auditives",
      "Medical Services and Supplies": "Services et Fournitures Médicales",
      "Medical Services And Supplies": "Services et Fournitures Médicales",
      "Medical Services & Supplies": "Services & Fournitures Médicales",
      "Medical Equipment": "Équipement Médical",
      "Apnea Machine (CPAP)": "Machine d'Apnée (CPAP)",
      "Apnea Machine": "Machine d'Apnée",
      "Apnea Machine Supplies": "Fournitures pour Machine d'Apnée",
      "Apnea Mask": "Masque pour Apnée",
      "Artificial Eye/Limb": "Œil/Membre Artificiel",
      "Artificial Eye/Limb Repair/Replacement": "Réparation/Remplacement Œil/Membre Artificiel",
      "Artificial Eye Limb Repair Replacement": "Réparation Remplacement Œil Membre Artificiel",
      "Blood Pressure Monitor": "Moniteur de Pression Artérielle",
      "Braces With Rigid Supports": "Orthèses avec Supports Rigides",
      "Compression Stockings": "Bas de Compression",
      Crutches: "Béquilles",
      "Blood Glucose Monitoring Equipment (CGM,BGM,FGM)": "Équipement de Surveillance de la Glycémie (CGM, BGM, FGM)",
      "Blood Glucose Monitoring Supplies (transmitters & sensors)": "Fournitures de Surveillance de la Glycémie (émetteurs et capteurs)",
      "Glucose Monitoring Equipment Supplies": "Fournitures d'équipement de surveillance de la glycémie",
      "Glucose Monitoring Equipment and Supplies": "Fournitures d'équipement de surveillance et de la glycémie",
      "Insulin Pump": "Pompe à Insuline",
      "Insulin Pump Supplies": "Les fournitures de pompe à insuline",
      "IPP Breathing Machine": "Machine de Respiration IPP",
      "Ostomy Supplies": "Fournitures pour Colostomie",
      "Surgical Bra": "Soutien-Gorge Chirurgical",
      "TENS Machine": "Machine TENS",
      "Tens Machine": "Machine Tens",
      Viscosupplementation: "Viscosupplémentation",
      "Wheelchair Manual": "Chaise Roulante Manuelle",
      "Wheelchair - Manual": "Chaise Roulante - Manuelle",
      "Wheelchair Electric": "Chaise Roulante Électrique",
      "Wheelchair - Electric": "Chaise Roulante - Électrique",
      Wigs: "Perruques",
      "Cardiac Rehabilitation": "Rééducation Cardiaque",
      "Convalescent Hospital": "Hôpital de Convalescence",
      "Erectile Dysfunction Drugs": "Médicaments pour Dysfonction Érectile",
      "Fertility Drugs": "Médicaments pour la Fertilité",
      "Preventative Vaccine": "Vaccin Préventif",
      "Preventative Vaccines": "Vaccines Préventif",
      "Smoking Cessation": "Arrêt du Tabagisme",
      "Smoking Cessations": "Arrêtes du Tabagisme",
      "Generic Drugs": "Médicaments Génériques",
      "Routine Care": "Soins de Routine",
      Periodontics: "Parodontologie",
      Endodontics: "Endodontie",
      Dentures: "Prothèses Dentaires",
      "Bridge Work": "Travail de Pont",
      Crowns: "Couronnes",
      Orthodontics: "Orthodontie",
      "Eye Exam": "Examen de la Vue",
      "Eye Glasses & Contacts": "Lunettes et Lentilles de Contact",
      "Required Safety Eyewear": "Lunettes de Sécurité Obligatoires",
      "Orthopedic Shoes": "Souliers orthopédiques, là",
      "Cataract Surgery Eyewear": "Lunettes pour la chirurgie de la cataracte, tsé",
      "Accidental Dental": "Dentaire accidentel, là.",
      "Dental Accident": "Dentaire accidentel, là.",
      'Basic Service (Endodontics, Periodontics, Routine Care (Visit and Treatment), Basic Oral Surgery)': 'Service de base (Endodontie, Parodontie, Soins de routine (Visite et Traitement), Chirurgie buccale de base)',
      'Major Services (Bridge Work, Crowns, Denture Repair, Dentures, Major Oral Surgery)': 'Services majeurs (Travail de pont, Couronnes, Réparation de prothèses, Prothèses, Chirurgie buccale majeure)',
      'Foot Orthotics': "Orthèses plantaires",
      "Stop Loss": "Limite d'arrêt",
      "Eye Exam Adult": "Examen de la vue pour adulte",
      "Eye Exam Child": "Examen de la vue pour enfant.",
      "Eye Glasses And Contacts Child": "Lunettes et lentilles de contact pour enfant.",
      "Eye Glasses And Contacts Adult": "Lunettes et lentilles de contact pour adulte",
      "Required Safety Eye Wear Child": "Équipement de protection oculaire requis pour enfant",
      "Required Safety Eye Wear Adult": "Équipement de protection oculaire requis pour adulte",
      "Routine Care Visit": "Visite de soins de routine",
      "Major Oral Surgery": "Chirurgie orale majeure",
      "Basic Oral Surgery": "Chirurgie orale de base",
      "Denture Repair": "Réparation de prothèse dentaire",
      "Massage Units": "Unités de massage",
      "Medic Alert Bracelet/Neck Chain": "Bracelet/Chaîne de cou d'alerte médicale",
      "Smoking Cessation Programs": "Programmes de sevrage tabagique",
      "Sun Care": "Soins solaires",
      "Vitamins and Supplements": "Vitamines et compléments alimentaires",
      "Weight Loss Programs": "Programmes de perte de poids",
      "Aromatherapy": "Aromathérapie",
      "Craniosacral": "Craniosacré",
      "Holistic Medicine or Practitioner": "Médecine holistique ou praticien",
      "Meditation Classes": "Cours de méditation",
      "Reflexology": "Réflexologie",
      "Reiki": "Reiki",
      "Cosmetic Dentistry": "Chirurgie dentaire esthétique",
      "Cosmetic Dermatology": "Dermatologie esthétique",
      "Cosmetic Procedures": "Interventions esthétiques",
      "Hair Replacement": "Remplacement capillaire",
      "Teeth Whitening": "Blanchiment des dents",
      "Child Daycare Services": "Services de garde d'enfants",
      "CPR Training": "Formation aux premiers secours (CPR)",
      "Language Programs": "Programmes linguistiques",
      "Parking": "Stationnement",
      "Transportation Expense": "Frais de transport",
      "Personal Development Course": "Cours de développement personnel",
      "Cell Phone": "Téléphone cellulaire",
      "Professional Membership": "Adhésion professionnelle",
      "Life Coach": "Coach de vie",
      "Legal Fees": "Frais juridiques",
      "Financial Advisor Fees": "Frais du conseiller financier",
      "RRSP/RESP Contribution Reimbursement": "Remboursement des cotisations au REER/REEE",
      "Dance Lessons": "Cours de danse",
      "Fitness Equipment": "Équipement de fitness",
      "Fitness Trackers": "Traceurs de fitness",
      "Golf (green fees)": "Golf (frais de terrain)",
      "Gym Membership": "Adhésion à la salle de sport",
      "Horseback Riding": "Équitation",
      "Kids Sports Fees": "Frais sportifs pour enfants",
      "Personal Training": "Entraînement personnel",
      "Self-defense Course": "Cours d'autodéfense",
      "Ski Passes": "Forfaits de ski",
      "Sporting Goods": "Articles de sport",
      "Yoga, Pilates, Barre": "Yoga, Pilates, Barre",
      "Ergonomic Office Equipment": "Équipement de bureau ergonomique",
      "Active Wear": "Vêtements de sport",
      "Flotation Therapy (float tank)": "Thérapie en caisson d'isolation sensorielle",
      "Doula Services": "Services de doula",
      "Elder Care": "Soins aux personnes âgées",
      "Handicapped Parking Permit": "Permis de stationnement pour personnes handicapées",
      "Lactation Consulting": "Consultation en lactation",
      "Personal Protective Equipment": "Équipement de protection individuelle",
      "Pet Daycare": "Garde d'animaux de compagnie",
      "Pet Insurance": "Assurance pour animaux de compagnie",
      "Prenatal Education Classes": "Cours d'éducation prénatale",
      "Safety Glasses": "Lunettes de protection",
      "Camping Fees": "Frais de camping",
      "Treatment Centre/Spas": "Centres de traitement/Spas",
      "Cleaning Services": "Services de nettoyage",
      "Veterinary Fees": "Frais vétérinaires",
      "Spa Services": "Services de spa",
      "Non-prescription Glasses/Sunglasses": "Lunettes de vue/sunglasses sans ordonnance",
      "All Service Types": "Tous les types de service",
      "Diagnostic Services": "Services de diagnostic",
      "Medical Referral": "Référence médicale",
      "Hospital Benefits Reimbursement": "Remboursement des frais hospitaliers",
      "Diagnostic Services Reimbursement": "Remboursement des services de diagnostic",
      "Diagnostic Services Max": "Maximum des services de diagnostic",
      "Dental Accident Max": "Maximum pour les accidents dentaires",
      "Dental Accident Reimbursement": "Remboursement des accidents dentaires",
      "Medical Referral Max": "Maximum des références médicales",
      "Medical Referral Reimbursement": "Remboursement des références médicales",
      "Blood Glucose Monitoring Supplies": "Fournitures de surveillance de la glycémie",
      "Blood Glucose Monitoring Equipment": "Équipement de surveillance de la glycémie",
      "Combined Maximum": "Maximum combiné",
      "Convalescent Hospital Reimbursement": "Remboursement pour hôpital de convalescence",
      "Convalescent Hospital Daily Max": "Maximum quotidien pour hôpital de convalescence",
      "Convalescent Hospital Max Days": "Nombre maximal de jours pour hôpital de convalescence",
      "Gender Affirmation": "Affirmation de genre",
      "Laser Eye Surgery": "Chirurgie oculaire au laser"
    }
  },
  statuses: {
    en: {
      Actif: "Active",
      Désactivé: "Disabled"
    },
    fr: {
      Active: "Actif",
      Disabled: "Désactivé"
    }
  },
  claimStatuses: {
    en: {
      approuvé: "approved",
      payé: "paid",
      refusé: "declined",
      inversé: "reversed",
      "en attente": "pending"
    },
    fr: {
      approved: "approuvé",
      paid: "payé",
      declined: "refusé",
      reversed: "inversé",
      pending: "en attente"
    }
  },
  benefitsPeriod: {
    en: {
      '2 ans': "2 Years",
      '5 ans': "5 Years",
      "Jusqu'à l'âge de 65 ans": "To Age 65"
    },
    fr: {
      "2 Years": '2 ans',
      "5 Years": '5 ans',
      "To Age 65": "Jusqu'à l'âge de 65 ans"
    }
  },
  defOfDisability: {
    en: {
      "2 ans en occupation propre, toute occupation par la suite": "2 Year Own Occupation, Any Occupation Thereafter",
      "5 ans en occupation propre, toute occupation par la suite": "5 Year Own Occupation, Any Occupation Thereafter",
      "2 ans en occupation propre, conditions couvertes en vertu de la prestation d\'invalidité hybride du membre du plan par la suite": "2 Year Own Occupation, Covered Conditions Under Plan Member Hybrid Disability Thereafter"
    },
    fr: {
      "2 Year Own Occupation, Any Occupation Thereafter": "2 ans en occupation propre, toute occupation par la suite",
      "5 Year Own Occupation, Any Occupation Thereafter": "5 ans en occupation propre, toute occupation par la suite",
      "2 Year Own Occupation, Covered Conditions Under Plan Member Hybrid Disability Thereafter": "2 ans en occupation propre, conditions couvertes en vertu de la prestation d\'invalidité hybride du membre du plan par la suite"
    }
  },
  earlyPaymentPrivilegeType: {
    en: {
      "Privilège de paiement anticipé : Égal au moindre de $50,000 ou 50% de la couverture du montant viager du participant au régime": "Early Payment Privilege: Equal to the lesser of $50,000 or 50% of the Plan Member Life Amount coverage",
      "Privilège de paiement anticipé = 50% du montant de la prestation vie de base applicable au membre. Le montant ne peut être inférieur à $5,000 ni supérieur à $50,000": "Early Payment Privilege = 50% of the amount of Basic Life Benefit applicable to the Member. The amount cannot be less than $5,000 or more than $50,000"
    },
    fr: {
      "Early Payment Privilege: Equal to the lesser of $50,000 or 50% of the Plan Member Life Amount coverage": "Privilège de paiement anticipé : Égal au moindre de $50,000 ou 50% de la couverture du montant viager du participant au régime",
      "Early Payment Privilege = 50% of the amount of Basic Life Benefit applicable to the Member. The amount cannot be less than $5,000 or more than $50,000": "Privilège de paiement anticipé = 50% du montant de la prestation vie de base applicable au membre. Le montant ne peut être inférieur à $5,000 ni supérieur à $50,000"
    }
  },
  genericSubstitute: {
    en: {
      "Nom de marque": "Brand Name",
      "Obligatoire en version générique": "Mandatory Generic",
      "Substitut générique": "Generic Substitution",
      "Formulaire CMP - Étudiant": "CMP Formulary - Student"
    },
    fr: {
      "Brand Name": "Nom de marque",
      "Mandatory Generic": "Obligatoire en version générique",
      "Generic Substitution": "Substitut générique",
      "CMP Formulary - Student": "Formulaire CMP - Étudiant"
    }
  },
  proratingPeriod: {
    en: {
      jour: "day",
      mois: 'month',
      quarter: "trimestre"
    },
    fr: {
      day: "jour",
      month: "mois",
      quarter: "trimestre"
    }
  },
  categories: {
    en: {
      "Médicaments": "Drugs",
      "Dentaire": "Dental",
      "Santé": "Health",
      "Paramédicaux": "Paramedicals",
      "Vision": "Vision",
      "Dépenses de style de vie": "Lifestyle Spending",
      "HSA": "HSA",
      "Toutes les catégories": "All Categories"
    },
    fr: {
      "Drugs": "Médicaments",
      "Dental": "Dentaire",
      "Health": "Santé",
      "Paramedicals": "Paramédicaux",
      "Vision": "Vision",
      "Lifestyle Spending": "Dépenses de style de vie",
      "All Categories": "Toutes les catégories"
    }
  },
  invoiceBenefits: {
    en: {
      "ILD": "LTD",
      "ICT": "STD",
      "Vie dépendant": "Dep Life",
      "Maladies graves": "CI",
      "Maladie grave (conjoint)": "CI (Spouse)",
      "Maladie grave (enfant)": "CI (Child)",
      "Santé": "Health",
      "Hors pays": "Out Of Country",
      "Limite d'arrêt": "Stop Loss",
      "Soins virtuels": "Virtual Healthcare",
      "PAEF": "EFAP",
      "Dentaire": "Dental",
      "Vie": "Life",
      "AD&M": "AD&D",
      "Maple": "Maple",
      "Gotodoctor": "Gotodoctor",
      "Dialogue": "Dialogue"
    },
    fr: {
      "LTD": "ILD",
      "STD": "ICT",
      "Dep Life": "Vie dépendant",
      "CI": "Maladies graves",
      "CI (Spouse)": "Maladie grave (conjoint)",
      "CI (Child)": "Maladie grave (enfant)",
      "Health": "Santé",
      "Out Of Country": "Hors pays",
      "Stop Loss": "Limite d'arrêt",
      "Virtual Healthcare": "Soins virtuels",
      "EFAP": "PAEF",
      "Dental": "Dentaire",
      "Life": "Vie",
      "AD&D": "AD&M",
      "Maple": "Maple",
      "Gotodoctor": "Gotodoctor",
      "Dialogue": "Dialogue"
    }
  },
  proofBenefits: {
    en: {
      "Médical Majeur": "Major Medical",
      "ILD": "Ltd",
      "ICT": "Std",
      "PAEF": "Efap",
      "Médicaments": "Drugs",
      "Assurance vie": "Life Insurance",
      "Paramédicaux": "Paramedicals",
      "Maladies graves": "Critical Illness",
      "Hors pays": "Out Of Country",
      "Soins virtuels": "Virtual Healthcare",
      "Vision": "Vision",
      "Assurance pour les personnes à charge": "Dependent Life",
      "Décès et mutilation": "Death Dismemberment"
    },
    fr: {
      "Major Medical": "Médical Majeur",
      "Ltd": "ILD",
      "Std": "ICT",
      "Efap": "PAEF",
      "Dental": "Dentaire",
      "Drugs": "Médicaments",
      "Life Insurance": "Assurance vie",
      "Paramedicals": "Paramédicaux",
      "Critical Illness": "Maladies graves",
      "Out Of Country": "Hors pays",
      "Virtual Healthcare": "Soins virtuels",
      "Vision": "Vision",
      "Dependent Life": "Assurance pour les personnes à charge",
      "Death Dismemberment": "Décès et mutilation"
    }
  },
  patients: {
    en: {
      "Tous les patients": "All Patients"
    },
    fr: {
      "All Patients": "Tous les patients"
    }
  },
  yearOptions: {
    en: {
      "Toutes les années": "All Years"
    },
    fr: {
      "All Years": "Toutes les années"
    }
  },
  dateRanges: {
    en: {
      "30 prochains jours": "Next 30 days",
      "60 prochains jours": "Next 60 days",
      "6 prochains mois": "Next 6 months",
      "12 prochains mois": "Next 12 months",
      "Cette année": "This Year",
      "30 derniers jours": "Last 30 days",
      "60 derniers jours": "Last 60 days",
      "6 derniers mois": "Last 6 months",
      "12 derniers mois": "Last 12 months",
      "Plage de dates personnalisée": "Custom Date Range",
      "Aujourd'hui": "Today"
    },
    fr: {
      "Next 30 days": "30 prochains jours",
      "Next 60 days": "60 prochains jours",
      "Next 6 months": "6 prochains mois",
      "Next 12 months": "12 prochains mois",
      "This Year": "Cette année",
      "Last 30 days": "30 derniers jours",
      "Last 60 days": "60 derniers jours",
      "Last 6 months": "6 derniers mois",
      "Last 12 months": "12 derniers mois",
      "Custom Date Range": "Plage de dates personnalisée",
      "Today": "Aujourd'hui"
    }
  },
  dateErrors: {
    en: {
      "Veuillez entrer une date : AAAA/MM/JJ": "Please enter a date: YYYY/MM/DD",
      "Date invalide": "Invalid date",
      "La date ne peut pas être dans le futur.": "Date cannot be in the future.",
      "La date ne peut pas être dans le passé.": "Date cannot be in the past.",
      "La date doit être le premier du mois.": "The date must be the first of the month.",
      "Type invalide transmis à getPastDate": "Invalid type passed to getPastDate",
      "Type invalide transmis à getFutureDate": "Invalid type passed to getFutureDate"
    },
    fr: {
      "Please enter a date: YYYY/MM/DD": "Veuillez entrer une date : AAAA/MM/JJ",
      "Invalid date": "Date invalide",
      "Date cannot be in the future.": "La date ne peut pas être dans le futur.",
      "Date cannot be in the past.": "La date ne peut pas être dans le passé.",
      "The date must be the first of the month.": "La date doit être le premier du mois.",
      "Invalid type passed to getPastDate": "Type invalide transmis à getPastDate",
      "Invalid type passed to getFutureDate": "Type invalide transmis à getFutureDate"
    }
  },
  earningsTypes: {
    en: {
      "Horaire": "Hourly",
      "Salaire": "Salary"
    },
    fr: {
      "Salary": "Salaire",
      "Hourly": "Horaire"
    }
  },
  reportTypes: {
    en: {
      "Anniversaire d'un membre en surâge": "Over Age Member Anniversary",
      "Liste des membres âgés": "Over Age Member Listing",
      "Liste des Dépendants": "Dependent Listing",
      "Liste des Dépendants en Excès d'Âge": "Overage Dependent Listing",
      "Utilisation du CDFS & CME": "HSA & LSA Usage",
      "Utilisation du Compte de Dépenses": "Spending Account Usages",
      "Solde du CDFS": "HSA Balance",
      "Solde du CME": "LSA Balance",
      "Liste des Certificats": "Certificate Listing",
      "Admissibilité au NEM": "NEM Eligibility",
      "Résumé Mensuel SAU": "ASO Monthly Summary",
      "Avantage Imposable": "Taxable Benefit",
      "Rapport LTD": "LTD Report",
      "Ratio de Perte": "Loss Ratio",
      "Rapport sur les principales procédures dentaires": "Top Dental Procedures"
    },
    fr: {
      "Over Age Member Anniversary": "Anniversaire d'un membre en surâge",
      "Over Age Member Listing": "Liste des membres âgés",
      "Dependent Listing": "Liste des Dépendants",
      "Overage Dependent Listing": "Liste des Dépendants en Excès d'Âge",
      "HSA & LSA Usage": "Utilisation du CDFS & CME",
      "Spending Account Usages": "Utilisation du Compte de Dépenses",
      "HSA Balance": "Solde du CDFS",
      "LSA Balance": "Solde du CME",
      "Certificate Listing": "Liste des Certificats",
      "NEM Eligibility": "Admissibilité au NEM",
      "ASO Monthly Summary": "Résumé Mensuel SAU",
      "Taxable Benefit": "Avantage Imposable",
      "LTD Report": "Rapport LTD",
      "Loss Ratio": "Ratio de Perte",
      "Top Dental Procedures": "Rapport sur les principales procédures dentaires"
    }
  },
  reportTitleExpansionKeys: {
    en: {
      "numéro de groupe": "groupNum",
      "société": "company",
      "division": "division"
    },
    fr: {
      "groupNum": "numéro de groupe",
      "company": "société",
      "division": "division"
    }
  },
  divisions: {
    en: {
      "Toutes les divisions": "All Divisions",
      "Toutes les divisions attribuées": "All Assigned Divisions"
    },
    fr: {
      "All Divisions": "Toutes les divisions",
      "All Assigned Divisions": "Toutes les divisions attribuées"
    }
  },
  nemBenefitOptions: {
    en: {
      'Tous': 'All',
      'Vie': 'Life',
      'Décès accidentel, mutilation': 'Accidental Death Dismemberment',
      'Incapacité de courte durée': 'Short Term Disability',
      'Invalidité de longue durée': 'Long Term Disability'
    },
    fr: {
      'All': 'Tous',
      'Life': 'Vie',
      'Accidental Death Dismemberment': 'Décès accidentel, mutilation',
      'Short Term Disability': 'Incapacité de courte durée',
      'Long Term Disability': 'Invalidité de longue durée'
    }
  },
  memberStatuses: {
    en: {
      'Tous': 'All',
      'Actif': 'Active',
      'Compte Désactivé': 'Account Disabled',
      'En Attente': 'Pending',
      'Candidats en Retard': 'Late Applicants',
      'Résilié': 'Terminated',
      'Congé parental': 'Parental Leave',
      'Congé non rémunéré': 'Leave of Absence',
      'Mise à pied temporaire': 'Temporary Lay Off',
      'Invalidité': 'Disability',
      'Grève': 'Strike',
      'Candidature tardive': 'Late Applicant',
      'Congé approuvé': 'Approved Leave',
      'Avantages du survivant': 'Survivor Benefits',
      'Indemnité de départ': 'Severance'
    },
    fr: {
      'All': 'Tous',
      'Active': 'Actif',
      'Account Disabled': 'Compte Désactivé',
      'Pending': 'En Attente',
      'Late Applicants': 'Candidats en Retard',
      'Terminated': 'Résilié',
      'Parental Leave': 'Congé parental',
      'Leave of Absence': 'Congé non rémunéré',
      'Temporary Lay Off': 'Mise à pied temporaire',
      'Disability': 'Invalidité',
      'Strike': 'Grève',
      'Late Applicant': 'Candidature tardive',
      'Approved Leave': 'Congé approuvé',
      'Survivor Benefits': 'Avantages du survivant',
      'Severance': 'Indemnité de départ'
    }
  },
  reportHeadings: {
    en: {
      "Certificat": "Certificate",
      "Identifiant de la Paie": "Payroll ID",
      "Statut": "Status",
      "Prénom": "First Name",
      "Nom de Famille": "Last Name",
      "Courriel": "Email",
      "Date de Naissance": "Birth Date",
      "Date d'embauche": "Hire Date",
      "Province": "Province",
      "Genre": "Gender",
      "Classe": "Class",
      "Division": "Division",
      "PayrollID": "PayrollID",
      "Profession": "Occupation",
      "Type de Revenu": "Earnings Type",
      "Revenus": "Earnings",
      "Type de Couverture": "Coverage Type",
      "Type EHB": "EHB Type",
      "Type de Dentaire": "DENT Type",
      "Principal": "Primary",
      "Dépendant": "Dependent",
      "Relation": "Relationship",
      "Renoncé": "Waived",
      "Employeur": "Employer",
      "Transporteur Secondaire": "Secondary Carrier",
      "Certificat Secondaire": "Secondary Cert",
      "Désactivé": "Disabled",
      "Nom": "Name",
      "Div": "Div",
      "CDFS": "HSA",
      "CME": "LSA",
      "Total": "Total",
      "Employé": "Employee",
      "Limite": "Limit",
      "Solde": "Balance",
      "Report à nouveau": "Carry Forward",
      "Solde reporté": "Carry Forward Balance",
      "Mois": "Month",
      "Solde d'ouverture": "Opening Balance",
      "Renflouement": "Top-up",
      "Prime": "Premium",
      "Demandes en cours": "Claims Out",
      "Frais de gestion": "Management Fee",
      "Frais d'administration": "Admin Fee",
      "TVH (Taxe de vente harmonisée)": "HST",
      "TVP (Taxe de vente provinciale)": "PST",
      "TPS (Taxe sur les produits et services)": "GST",
      "TVR (Taxe de vente au détail)": "RST",
      "Solde de clôture": "Closing Balance",
      "Vie": "Life",
      "AD&M": "AD&D",
      "Vie dépendant": "DepLife",
      "Invalidité de longue durée": "CI",
      "Tous": "All",
      "TVP/TVD": "PST/RST",
      "Membre": "Member",
      "ILD": "LTD",
      "ICT": "STD",
      "Volume": "Volume",
      "Admissible": "Eligible",
      "Étudiant": "Student",
      "Date de résiliation": "Termination Date",
      "Date de réintégration": "Reinstatement Date",
      "Organisation": "Organization",
      "Carte d'étudiant": "Student ID",
      "Programme d'études": "Degree/Program",
      "Date de début de l'étude": "Study Start Date"
    },
    fr: {
      "Certificate": "Certificat",
      "Payroll ID": "Identifiant de la Paie",
      "Status": "Statut",
      "First Name": "Prénom",
      "Last Name": "Nom de Famille",
      "Email": "Courriel",
      "Birth Date": "Date de Naissance",
      "Hire Date": "Date d'embauche",
      "Province": "Province",
      "Gender": "Genre",
      "Class": "Classe",
      "Division": "Division",
      "PayrollID": "PayrollID",
      "Occupation": "Profession",
      "Earnings Type": "Type de Revenu",
      "Earnings": "Revenus",
      "Coverage Type": "Type de Couverture",
      "EHB Type": "Type EHB",
      "DENT Type": "Type de Dentaire",
      "Primary": "Principal",
      "Dependent": "Dépendant",
      "Relationship": "Relation",
      "Waived": "Renoncé",
      "Employer": "Employeur",
      "Secondary Carrier": "Transporteur Secondaire",
      "Secondary Cert": "Certificat Secondaire",
      "Disabled": "Désactivé",
      "Name": "Nom",
      "Div": "Div",
      "HSA": "CDFS",
      "LSA": "CME",
      "Total": "Total",
      "Employee": "Employé",
      "Limit": "Limite",
      "Balance": "Solde",
      "Carry Forward": "Report à nouveau",
      "Carry Forward Balance": "Solde reporté",
      "Month": "Mois",
      "Opening Balance": "Solde d'ouverture",
      "Top-up": "Renflouement",
      "Premium": "Prime",
      "Claims Out": "Demandes en cours",
      "Management Fee": "Frais de gestion",
      "Admin Fee": "Frais d'administration",
      "HST": "TVH (Taxe de vente harmonisée)",
      "PST": "TVP (Taxe de vente provinciale)",
      "GST": "TPS (Taxe sur les produits et services)",
      "RST": "TVR (Taxe de vente au détail)",
      "Closing Balance": "Solde de clôture",
      "Cert": "Certificat",
      "Life": "Vie",
      "AD&D": "AD&M",
      "DepLife": "Vie dépendant",
      "CI": "Invalidité de longue durée",
      "All": "Tous",
      "PST/RST": "TVP/TVD",
      "Member": "Membre",
      "LTD": "ILD",
      "STD": "ICT",
      "Volume": "Volume",
      "Eligible": "Admissible",
      "Student": "Étudiant",
      "Termination Date": "Date de résiliation",
      "Reinstatement Date": "Date de réintégration",
      "Organization": "Organisation",
      "Student ID": "Carte d'étudiant",
      "Degree/Program": "Programme d'études",
      "Study Start Date": "Date de début de l'étude"
    }
  },
  healthDentalOptions: {
    en: {
      "Santé": "Health",
      "Dentaire": "Dental",
      "Les Deux": "Both"
    },
    fr: {
      "Health": "Santé",
      "Dentaire": "Dental",
      "Both": "Les Deux"
    }
  },
  invoiceStatuses: {
    en: {
      "En attente": "Pending",
      "Échoué": "Failed",
      "Payé": "Paid",
      "Arrêté": "Stopped"
    },
    fr: {
      "Pending": "En attente",
      "Failed": "Échoué",
      "Paid": "Payé",
      "Stopped": "Arrêté"
    }
  },
  accountStatuses: {
    en: {
      "Actif": "Active",
      "En attente de la mise en production": "Pending Go Live",
      "Recensement": "Census"
    },
    fr: {
      "Active": "Actif",
      "Pending Go Live": "En attente de la mise en production",
      "Census": "Recensement"
    }
  },
  quoteStatuses: {
    en: {
      "Vendu": "Sold",
      "En cours": "In Progress",
      "Perdu": "Lost"
    },
    fr: {
      Sold: "Vendu",
      "In Progress": "En cours",
      Lost: "Perdu"
    }
  },
  quoteStates: {
    en: {
      'Configuration': 'Setup',
      'Commissions': 'Commissions',
      'Demande principale': 'Master Application',
      'En attente d\'analyse': 'Pending Underwriting',
      'Attribution de plan': 'Plan Assignment',
      'Demande d\'approbation': 'Request Approval',
      'En cours d\'examen': 'Under Review',
      'Approuvé': 'Approved',
      'Vendu': 'Sold'
    },
    fr: {
      'Setup': 'Configuration',
      'Commissions': 'Commissions',
      'Master Application': 'Demande principale',
      'Pending Underwriting': 'En attente d\'analyse',
      'Plan Assignment': 'Attribution de plan',
      'Request Approval': 'Demande d\'approbation',
      'Under Review': 'En cours d\'examen',
      'Approved': 'Approuvé',
      'Sold': 'Vendu'
    }
  },
  yesOrNo: {
    en: {
      "Oui": "Yes",
      "Non": "No"
    },
    fr: {
      "Yes": "Oui",
      "No": "Non"
    }
  },
  beneficiariesOptions: {
    en: {
      "Révocable": "Revocable",
      "Irrévocable": "Irrevocable"
    },
    fr: {
      "Revocable": "Révocable",
      "Irrevocable": "Irrévocable"
    }
  },
  languages: {
    en: {
      "Anglais": "English",
      "Français": "French"
    },
    fr: {
      "English": "Anglais",
      "French": "Français"
    }
  },
  rolloverOptions: {
    en: {
      "Année civile": "Calendar Year",
      "Durée de vie": "Lifetime",
      "Par voyage": "Per Trip"
    },
    fr: {
      "Calendar Year": "Année civile",
      "Lifetime": "Durée de vie",
      "Per Trip": "Par voyage"
    }
  },
  journey: {
    en: {
      "Courriel": "Email",
      "Nom": "Name",
      "Date de naissance": "Birth Date",
      "Relation": "Relationship",
      "Province": "Province",
      "Adresse": "Address",
      "Type de revenu": "Earnings Type",
      "Salaire": "Salary",
      "Taux horaire": "Hourly Wage",
      "Heures par semaine": "Hours Per Week",
      "Date d'embauche": "Hire Date",
      "Genre": "Gender",
      "Occupation": "Occupation",
      "Type de couverture": "Coverage",
      "État civil": "Marital Status",
      "Classe": "Class",
      "Division": "Division",
      "Statut": "Status",
      "Mot de passe": "Password",
      "Statut de renonciation": "Waived Status",
      "Actions": "Shares",
      "Statut de période de renonciation": "Waiting Period Status",
      "Identifiant de paie": "Payroll ID",
      "Comptes de dépenses": "Spending Accounts",
      "Avantages de soins de santé virtuels": "Virtual Healthcare Benefits",
      "Avantages hors province et à l'étranger": "Out of Province and Country Benefits",
      "Assistance aux employés": "Employee Assistance",
      "Vision": "Vision",
      "Paramédicaux": "Paramedicals",
      "Soins médicaux majeurs": "Major Medical",
      "Dentaire": "Dental",
      "Médicaments": "Drugs",
      "Invalidité à court terme": "Short Term Disability",
      "Invalidité à long terme": "Long Term Disability",
      "Assurance vie dépendante": "Dependent Life",
      "Décès et mutilation": "Death & Dismemberment",
      "Assurance vie": "Life Insurance",
      "Maladie grave": "Critical Illness",
      "Avantages actifs": "Benefits Active",
      "Invalidité": "Disability",
      "Actif": "Active"
    },
    fr: {
      "Email": "Courriel",
      "Name": "Nom",
      "Birth Date": "Date de naissance",
      "Relationship": "Relation",
      "Province": "Province",
      "Address": "Adresse",
      "Earnings Type": "Type de revenu",
      "Salary": "Salaire",
      "Hourly Wage": "Taux horaire",
      "Hours Per Week": "Heures par semaine",
      "Hire Date": "Date d'embauche",
      "Gender": "Genre",
      "Occupation": "Occupation",
      "Coverage": "Type de couverture",
      "Marital Status": "État civil",
      "Class": "Classe",
      "Division": "Division",
      "Status": "Statut",
      "Password": "Mot de passe",
      "Waived Status": "Statut de renonciation",
      "Shares": "Actions",
      "Waiting Period Status": "Statut de période de renonciation",
      "Payroll ID": "Identifiant de paie",
      "Spending Accounts": "Comptes de dépenses",
      "Virtual Healthcare Benefits": "Avantages de soins de santé virtuels",
      "Out of Province and Country Benefits": "Avantages hors province et à l'étranger",
      "Employee Assistance": "Assistance aux employés",
      "Vision": "Vision",
      "Paramedicals": "Paramédicaux",
      "Major Medical": "Soins médicaux majeurs",
      "Dental": "Dentaire",
      "Drugs": "Médicaments",
      "Short Term Disability": "Invalidité à court terme",
      "Long Term Disability": "Invalidité à long terme",
      "Dependent Life": "Assurance vie dépendante",
      "Death & Dismemberment": "Décès et mutilation",
      "Life Insurance": "Assurance vie",
      "Critical Illness": "Maladie grave",
      "Benefits Active": "Avantages actifs",
      "Disability": "Invalidité",
      "Active": "Actif"
    }
  },
  classes: {
    en: {
      "Toutes les classes": "All Classes"
    },
    fr: {
      "All Classes": "Toutes les classes"
    }
  },
  waivedOrNotWaived: {
    en: {
      "Renoncé": "Waived",
      "Pas de renonciation": "Not Waived"
    },
    fr: {
      "Waived": "Renoncé",
      "Not Waived": "Pas de renonciation"
    }
  },
  commissionStatus: {
    en: {
      "Tout": "All",
      "Payé": "Paid",
      "En attente": "Pending",
      "Échoué": "Failed"
    },
    fr: {
      "All": "Tout",
      "Payé": "Paid",
      "Pending": "En attente",
      "Failed": "Échoué"
    }
  },
  amendmentStatuses: {
    en: {
      'En cours': 'In Progress',
      "Sous revue": 'Under Review',
      'Approuvé': 'Approved',
      'En révision': 'Under Revision',
      'En attente': 'Pending',
      'Terminé': 'Complete'
    },
    fr: {
      'In Progress': 'En cours',
      'Under Review': "Sous revue",
      'Approved': 'Approuvé',
      'Under Revision': 'En révision',
      'Pending': 'En attente',
      'Complete': 'Terminé'
    }
  },
  planMaximumOptions: {
    en: {
      'Montant en dollars': 'Dollar Amount',
      'Reste': 'Remainder'
    },
    fr: {
      'Dollar Amount': 'Montant en dollars',
      'Remainder': 'Reste'
    }
  },
  preferredProvider: {
    en: {
      "Autre": "Other",
      "Costco": "Costco",
      "Pocket Pills": "Pocket Pills",
      "Costco et Pocket Pills": "Costco & Pocket Pills"
    },
    fr: {
      "Other": "Autre",
      "Costco": "Costco",
      "Pocket Pills": "Pocket Pills",
      "Costco & Pocket Pills": "Costco et Pocket Pills"
    }
  },
  drugsMaximumType: {
    en: {
      "Montant en dollars": "Dollar Amount",
      "Illimité": "Unlimited"
    },
    fr: {
      "Dollar Amount": "Montant en dollars",
      "Unlimited": "Illimité"
    }
  },
  hospitalBenefitsType: {
    en: {
      "Privé": "Private",
      "Semi-privé": "Semi-private"
    },
    fr: {
      "Private": "Privé",
      "Semi-private": "Semi-privé"
    }
  },
  coverageRolloverPeriod: {
    en: {
      "Durée de vie": "Lifetime",
      "Année civile": "Calendar Year",
      "Par voyage": "Per Trip"
    },
    fr: {
      "Lifetime": "Durée de vie",
      "Calendar Year": "Année civile",
      "Per Trip": "Par voyage"
    }
  },
  coveragePeriod: {
    en: {
      "30 jours": "30 Days",
      "60 jours": "60 Days",
      "90 jours": "90 Days",
      "120 jours": "120 Days",
      "180 jours": "180 Days"
    },
    fr: {
      "30 Days": "30 jours",
      "60 Days": "60 jours",
      "90 Days": "90 jours",
      "120 Days": "120 jours",
      "180 Days": "180 jours"
    }
  },
  accountHistoryTypes: {
    en: {
      "Recensement": "Census",
      "Historique des taux": "Rate History",
      "Historique des réclamations": "Claims History",
      "Facture précédente": "Past Bill",
      "E-mails": "Emails",
      "Documents à l'appui": "Supporting Documents"
    },
    fr: {
      "Census": "Recensement",
      "Rate History": "Historique des taux",
      "Claims History": "Historique des réclamations",
      "Past Bill": "Facture précédente",
      "Emails": "E-mails",
      "Supporting Documents": "Documents à l'appui"
    }
  },
  changeRequestStatuses: {
    en: {
      "En attente de l'approbation de l'administrateur": "Pending Admin Approval",
      "En attente de l'approbation des membres": "Pending Member Approval",
      "Nécessite un examen par l'administrateur": "Needs Admin Review",
      "Nécessite un examen par les membres": "Needs Member Review",
      "Examen des besoins": "Needs Review",
      "Incomplet": "Incomplete",
      "Suspendu": "Suspended",
      "Approuvé": "Approved",
      "Refusé": "Declined",
      "Inversé": "Reversed",
      "En attente": "Pending"
    },
    fr: {
      "Pending Admin Approval": "En attente de l'approbation de l'administrateur",
      "Pending Member Approval": "En attente de l'approbation des membres",
      "Needs Admin Review": "Nécessite un examen par l'administrateur",
      "Needs Member Review": "Nécessite un examen par les membres",
      "Needs Review": "Examen des besoins",
      "Incomplete": "Incomplet",
      "Suspended": "Suspendu",
      "Approved": "Approuvé",
      "Declined": "Refusé",
      "Reversed": "Inversé",
      "Pending": "En attente"
    }
  },
  changeRequestTypes: {
    en: {
      "Modifier les détails du membre": "Edit Member Details",
      "Modifier les détails de l'emploi": "Edit Employment Details",
      "Ajouter un dépendant": "Add a Dependent",
      "Supprimer un dépendant": "Remove a Dependent",
      "Modifier les détails du dépendant": "Edit Dependent Details",
      "Ajouter un bénéficiaire irrévocable": "Add Irrevocable Beneficiary",
      "Modifier le bénéficiaire irrévocable": "Edit Irrevocable Beneficiary",
      "Supprimer le bénéficiaire irrévocable": "Remove Irrevocable Beneficiary",
      "Ajouter un bénéficiaire révocable": "Add Revocable Beneficiary",
      "Modifier le bénéficiaire révocable": "Edit Revocable Beneficiary",
      "Supprimer le bénéficiaire révocable": "Remove Revocable Beneficiary",
      "Ajouter un fiduciaire": "Add Trustee",
      "Modifier le fiduciaire": "Edit Trustee",
      "Supprimer le fiduciaire": "Remove Trustee",
      "Renoncer aux avantages": "Waive Benefits",
      "Réintégrer les avantages": "Reinstate Benefits",
      "Changer de classe": "Change Class",
      "Changer la date d'embauche": "Change Hire Date",
      "Changer la période d'attente": "Change Waiting Period"
    },
    fr: {
      "Edit Member Details": "Modifier les détails du membre",
      "Edit Employment Details": "Modifier les détails de l'emploi",
      "Add a Dependent": "Ajouter un dépendant",
      "Remove a Dependent": "Supprimer un dépendant",
      "Edit Dependent Details": "Modifier les détails du dépendant",
      "Add Irrevocable Beneficiary": "Ajouter un bénéficiaire irrévocable",
      "Edit Irrevocable Beneficiary": "Modifier le bénéficiaire irrévocable",
      "Remove Irrevocable Beneficiary": "Supprimer le bénéficiaire irrévocable",
      "Add Revocable Beneficiary": "Ajouter un bénéficiaire révocable",
      "Edit Revocable Beneficiary": "Modifier le bénéficiaire révocable",
      "Remove Revocable Beneficiary": "Supprimer le bénéficiaire révocable",
      "Add Trustee": "Ajouter un fiduciaire",
      "Edit Trustee": "Modifier le fiduciaire",
      "Remove Trustee": "Supprimer le fiduciaire",
      "Waive Benefits": "Renoncer aux avantages",
      "Reinstate Benefits": "Réintégrer les avantages",
      "Change Class": "Changer de classe",
      "Change Hire Date": "Changer la date d'embauche",
      "Change Waiting Period": "Changer la période d'attente"
    }
  },
  userType: {
    en: {
      "Membre": "Member",
      "Administrateur": "Administrator"
    },
    fr: {
      "Member": "Membre",
      "Administrator": "Administrateur"
    }
  },
  primaryBenefits: {
    en: {
      "Médicaments": "Drugs",
      "Médical Majeur": "Major Medical",
      "Hors du pays et de la province": "Out of Country & Province",
      "Vision": "Vision",
      "Dentaire": "Dental",
      "Paramédical": "Paramedical"
    },
    fr: {
      "Drugs": "Médicaments",
      "Major Medical": "Médical Majeur",
      "Out of Country & Province": "Hors du pays et de la province",
      "Vision": "Vision",
      "Dental": "Dentaire",
      "Paramedical": "Paramédical"
    }
  },
  waiveFor: {
    en: {
      'Moi seulement': 'Myself Only',
      'Moi et les personnes à charge': 'Myself & Dependents',
      'Personnes à charge uniquement': 'Dependents Only'
    },
    fr: {
      'Myself Only': 'Moi seulement',
      'Myself & Dependents': 'Moi et les personnes à charge',
      'Dependents Only': 'Personnes à charge uniquement'
    }
  },
  waiveBenefits: {
    en: {
      'Soins de santé prolongés': 'Extended Healthcare',
      'Dentaire': 'Dental',
      'Soins de santé étendus et soins dentaires': 'Extended Healthcare & Dental'
    },
    fr: {
      'Extended Healthcare': 'Soins de santé prolongés',
      'Dental': 'Dentaire',
      'Extended Healthcare & Dental': 'Soins de santé étendus et soins dentaires'
    }
  }
};